import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MeterDownloadWizardFilter } from '@app/shared/models/meter/meter-download-wizard-data';
import { TranslateService } from '@ngx-translate/core';
import { MeterDownloadWizardUtility } from '../meter-download-wizard-utility';

@Component({
  selector: 'app-file-extension-selection',
  templateUrl: './file-extension-selection.component.html',
  styleUrls: ['./file-extension-selection.component.scss'],
})
export class FileExtensionSelectionComponent implements OnInit {
  @Input() filter: Partial<MeterDownloadWizardFilter> = {} as MeterDownloadWizardFilter;
  @Output() title = new EventEmitter<string>();
  @Output() nextButtonStatus = new EventEmitter<boolean>();
  @Output() fileExtension = new EventEmitter<string>();

  options = [
    { type: 'csv', name: 'CSV (Comma Separated Value)' },
    { type: 'xlsx', name: 'XLSX (Microsoft Excel)' },
  ];

  constructor(public translate: TranslateService) {}

  public ngOnInit() {
    this.title.emit(this.translate.instant('module.shared.excelDownloadWizard.titleText4'));
    this.nextButtonStatus.emit(MeterDownloadWizardUtility.isNextButtonDisabled(this.filter.fileExtension));
  }

  public onSelectionChange(value: string) {
    this.fileExtension.emit(value);
    this.nextButtonStatus.emit(false);
  }
}
